import { getIn } from 'seamless-immutable';
import { stringify } from 'query-string';
import { sendBeacon } from '@catalogo/core-send-beacon';
import { readCookies } from '@catalogo/core-connect/cookies';

export const sendBeaconWebVitals = ({ config, client, body }) => {
  const { cookies } = readCookies(client);

  const brand = config.brand.toUpperCase();
  const ga = getIn(cookies, ['_ga'], '').slice(6);
  const dataLayer = getIn(window, ['dataLayer'], []);
  const pageview = dataLayer.find(elem => elem?.event?.includes('pageview'));
  const pagename = getIn(pageview, ['pagename'], brand);
  const appId = dataLayer.find(events => Object.keys(events).find(key => key === 'AppID')).AppID;

  const params = {
    t: 'event',
    tid: config.ga,
    ec: 'performance',
    ea: 'webvitals',
    el: JSON.stringify([...body]),
    cid: ga,
    uid: cookies['B2W-UID'],
    cd1: cookies['B2W-UID'],
    cd4: appId,
    cd44: 'Responsivo',
    cd60: cookies['B2W-PID'],
    cd61: cookies['B2W-SID'],
    cd104: pagename,
    dt: document.title,
    dl: window.location.href,
    dp: `${window.location.pathname}${window.location.search}`,
    ni: 1,
  };

  try {
    sendBeacon(`https://www.google-analytics.com/j/collect?v=1&${stringify(params)}`);
  } catch (e) {
    console.info(e);
  }
};
